// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".clip-size-label{--text-opacity:1;color:#a0aec0;color:rgba(160,174,192,var(--text-opacity));font-size:.875rem}", ""]);
// Exports
module.exports = exports;
